module.exports = __webpack_public_path__ + "static/media/logo_harinera.721d5338.jpg";